import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-sm",
  "use": "icon-checkmark-sm-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" id=\"icon-checkmark-sm\"><path d=\"M.5 5l2 2 6-5\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-checkmark-sm.svg
// module id = 857
// module chunks = 74